/** Readable sample-peak display: 2 s hold, marker release at 12 dB/s.
 * Numeric values step down after the hold instead of counting down every frame.
 * Pass a monotonic clock so ballistics are independent of screen refresh rate.
 */
export class PeakHold {
  private numeric = 0;
  private marker = 0;
  private numericUntil = 0;
  private markerUntil = 0;
  private lastMs = 0;

  update(peak: number, nowMs: number): { numeric: number; marker: number } {
    peak = Number.isFinite(peak) ? Math.max(0, peak) : 0;
    if (peak >= this.numeric || nowMs >= this.numericUntil) {
      this.numeric = peak;
      this.numericUntil = nowMs + 2000;
    }
    const releaseMs = Math.max(0, nowMs - Math.max(this.lastMs, this.markerUntil));
    this.marker *= 10 ** (-12 * releaseMs / 1000 / 20);
    if (peak >= this.marker) {
      this.marker = peak;
      this.markerUntil = nowMs + 2000;
    }
    this.lastMs = nowMs;
    return { numeric: this.numeric, marker: this.marker };
  }

  reset(): void {
    this.numeric = this.marker = 0;
    this.numericUntil = this.markerUntil = this.lastMs = 0;
  }
}
